<template>
  <div class="mx-auto">
    <div class="clearfix">
      <div class="float-left w-100">
        <mdb-row class="my-3">
          <mdb-col md="2" class="text-right">능력단위명</mdb-col>
          <mdb-col md="10"><input class="input-underline w-50" v-model="lecture.name"/></mdb-col>
        </mdb-row>
        <mdb-row class="my-3">
          <mdb-col md="2" class="text-right">능력단위 분류번호</mdb-col>
          <mdb-col md="10"><input class="input-underline w-50" v-model="lecture.code"/></mdb-col>
        </mdb-row>
        <mdb-row class="my-3">
          <mdb-col md="2" class="text-right">수준</mdb-col>
          <mdb-col md="1">
            <select v-model="lecture.level">
              <option v-for="ix in 10" :key="ix">{{ix}}</option>
            </select>
          </mdb-col>
        </mdb-row>
        <mdb-row class="my-3">
          <mdb-col md="2" class="text-right">훈련 시간</mdb-col>
          <mdb-col md="1"><input class="input-underline w-100" v-model="lecture.hours"/></mdb-col>
        </mdb-row>
      </div>
      <div class="float-right"><mdb-btn icon="list" class="py-2" @click="$emit('mode-change')">목록</mdb-btn></div>
    </div>
    <hr/>

    <div v-for="(unit, ux) in lecture.units" :key="ux">
      <mdb-row>
        <mdb-col md="4"><mdb-input label="능력단위 요소명" v-model="unit.name" class="mb-0"/></mdb-col>
        <mdb-col md="3"><mdb-input label="능력단위 요소코드" v-model="unit.code" class="mb-0"/></mdb-col>
        <mdb-col md="3"><mdb-btn icon="times" class="p-1 mt-4" color="danger" @click="onDeleteElement(ux)">요소 삭제</mdb-btn></mdb-col>
      </mdb-row>
      <mdb-row>
        <mdb-col md="2" class="title bolder my-3 text-right">훈련 내용</mdb-col>
        <mdb-col md="10">
          <div v-for="(content, cx) in unit.content" :key="cx" class="my-3">
            <div class="clearfix">
              <div class="float-left w-90"><input class="input-underline w-100" v-model="unit.content[cx]"/></div>
              <div class="float-right"><mdb-btn icon="times" class="m-0 p-1" color="danger" @click="onDeleteContent(unit.content, cx)"></mdb-btn></div>
            </div>
          </div>
          <div><mdb-btn icon="plus" class="p-1 m-0"  @click="onAddContent(unit.content)">내용추가</mdb-btn></div>
        </mdb-col>
      </mdb-row>
    </div>
    <div><mdb-btn icon="plus" class="p-1 m-0" color="primary" @click="onAddElement()">요소추가</mdb-btn></div>
  </div>
</template>
<script>
import { mdbTbl, mdbTblHead, mdbTblBody } from 'mdbvue'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import NcsTraining from '@/models/NcsTraining'
export default {
  name: 'StaffNcsTrainingLectureEdit',
  // components: { mdbTbl, mdbTblHead, mdbTblBody },
  props: ['lecture'],
  data: () => ({
    TAG: 'StaffNcsTrainingLectureEdit'
  }),
  methods: {
    onAddContent (content) {
      content.push('')
    },
    onDeleteContent (content, cx) {
      content.splice(cx, 1)
    },
    onAddElement () {
      const element = {
        name: '',
        code: this.lecture.code + '.' + (this.lecture.units.length + 1),
        content: ['', '', '']
      }
      this.lecture.units.push(element)
    },
    onDeleteElement (cx) {
      if (!confirm('요소를 삭제할까요?')) return
      this.lecture.units.splice(cx, 1)
    }

  },
  created () {
  }
}
</script>
